const types = {
  THROW_API_ERROR: '@@IO_API/THROW_API_ERROR',
};

export default types;
